import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { OnOffSwitch, Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { TOOLTIP_DELAY_MS } from "app/modules/project-from-comparison/config";
import { useProjectCreation } from "app/modules/project-from-comparison/context";
import { projectCreationDataAutomation } from "app/modules/project-from-comparison/dataAutomation";
import projectCreatingTrack from "app/modules/project-from-comparison/tracking";

import { WEEKLY_UPDATES_LABEL, WEEKLY_UPDATES_TOOLTIP } from "./text";

const { carbon } = colorsPalettes;

export const WeeklyUpdatesSwitch = () => {
    const { isWeeklyUpdatesEnabled, setWeeklyUpdates } = useProjectCreation();
    const { translate } = useTranslate();

    const handleWeeklyUpdatesToggle = (): void => {
        setWeeklyUpdates(!isWeeklyUpdatesEnabled);

        projectCreatingTrack.trackWeeklyUpdatesToggle(!isWeeklyUpdatesEnabled);
    };

    return (
        <Flex
            gap="4px"
            alignItems="center"
            data-automation={projectCreationDataAutomation.weeklyUpdates.container}
        >
            <OnOffSwitch
                onClick={handleWeeklyUpdatesToggle}
                isSelected={isWeeklyUpdatesEnabled}
                className="subscriptionSwitch"
            />

            <Flex
                gap="8px"
                alignItems="center"
            >
                <Text
                    fontVariant="body2"
                    color={carbon[400]}
                    data-automation={projectCreationDataAutomation.weeklyUpdates.label}
                >
                    {translate(WEEKLY_UPDATES_LABEL)}
                </Text>

                <Tooltip
                    content={translate(WEEKLY_UPDATES_TOOLTIP)}
                    delay={{ open: TOOLTIP_DELAY_MS }}
                >
                    <SWReactIcons
                        iconName="info"
                        iconColor={carbon[200]}
                        size="xs"
                    />
                </Tooltip>
            </Flex>
        </Flex>
    );
};
